import { Link } from "react-router-dom";
import { CheckCircle2, ArrowUpRight } from "lucide-react";
import SEO from "@/components/SEO";

export default function Danke() {
  return (
    <section className="relative min-h-[80vh] flex items-center overflow-hidden">
      <SEO
        title="Danke – Ihre Anfrage ist bei PINE Systems eingegangen"
        description="Vielen Dank für Ihre Anfrage. Wir melden uns umgehend bei Ihnen."
        noindex
      />
      <div className="absolute inset-0 grid-overlay opacity-40" />
      <div className="relative max-w-3xl mx-auto px-6 md:px-12 py-24 text-center w-full">
        <div className="overline mb-6 mx-auto">Eingegangen</div>
        <CheckCircle2
          size={64}
          strokeWidth={1.25}
          className="text-[#18E096] mx-auto"
          aria-hidden
        />
        <h1
          className="font-display text-4xl md:text-6xl uppercase mt-8 leading-[1.05]"
          data-testid="danke-headline"
        >
          Danke für Ihre <br />
          <span className="text-[#18E096]">Einreichung.</span>
        </h1>
        <p className="text-[#AEB7B7] mt-8 text-base md:text-lg leading-relaxed max-w-xl mx-auto">
          Ihre Anfrage ist bei uns eingegangen, wir melden uns umgehend bei Ihnen.
        </p>
        <p className="text-[#AEB7B7] mt-4 text-sm md:text-base leading-relaxed max-w-xl mx-auto">
          Der nächste Schritt ist keine Kaufentscheidung, sondern eine strukturierte Einschätzung
          Ihres Standortpotenzials. Wir kommen mit den passenden nächsten Fragen auf Sie zu.
        </p>

        <div className="mt-12 flex flex-wrap justify-center gap-3">
          <Link to="/ablauf" className="btn-primary" data-testid="danke-cta-ablauf">
            Ablauf ansehen <ArrowUpRight size={16} strokeWidth={1.5} />
          </Link>
          <Link to="/" className="btn-secondary" data-testid="danke-cta-home">
            Zur Startseite
          </Link>
        </div>

        <div className="mt-12 pt-8 border-t border-[rgba(255,255,255,0.08)] max-w-md mx-auto">
          <div className="overline mb-2">Direktkontakt</div>
          <a
            href="mailto:partner@pinexs.de"
            className="text-white hover:text-[#18E096] transition-colors text-base"
            data-testid="danke-direct-email"
          >
            partner@pinexs.de
          </a>
        </div>
      </div>
    </section>
  );
}
